module.exports = __webpack_public_path__ + "static/img/360aq_img_3.b9357aa7.png";